module.exports = __webpack_public_path__ + "static/media/builtinv2-Иконка гарантия.cc7d7fa0.svg";